// Staff (people) features for the Live Map's unified `vehicles` cluster
// source, plus the MapLibre filter expressions the SOS halo layers use.
// Pure so the property shape and the filters can be tested together — the
// halo only works while these two agree (MyCRM 233).

/**
 * Build GeoJSON features for staff people from Redux (`state.staff.byUserId`).
 * Mirrored into the same cluster source as vehicles so the cluster bubble
 * shows a combined count and is colored by composition.
 */
export function buildStaffFeatures(staffByUserId) {
  return Object.values(staffByUserId ?? {})
    .map((row) => {
      if (!row?.lastFix) return null;
      const lng = Number(row.lastFix.longitude);
      const lat = Number(row.lastFix.latitude);
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
      return {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [lng, lat] },
        properties: {
          kind: 'staff',
          user_id: row.userId,
          name: row.name ?? '',
          staffRole: row.staffRole,
          shiftActive: row.shift != null,
          // `sos` is the person's OPEN (unacknowledged) alert from
          // /api/staff/positions/latest — null once it is acknowledged, which
          // is what turns the halo off again.
          sosActive: row.sos != null,
          fixTime: row.lastFix.fixTime,
        },
      };
    })
    .filter(Boolean);
}

/** clusterProperties entry: how many SOS people a cluster bubble contains. */
export const SOS_COUNT_CLUSTER_PROPERTY = ['+', ['case', ['==', ['get', 'sosActive'], true], 1, 0]];

/** Unclustered staff point with an active SOS. */
export const STAFF_SOS_HALO_FILTER = [
  'all',
  ['!', ['has', 'point_count']],
  ['==', ['get', 'kind'], 'staff'],
  ['==', ['get', 'sosActive'], true],
];

/** A cluster bubble that contains at least one SOS person. */
export const CLUSTER_SOS_HALO_FILTER = [
  'all',
  ['has', 'point_count'],
  ['>', ['get', 'sos_count'], 0],
];
